export default function getSkillAreaWidth(skillArea) {
  return Math.max(20 * skillArea.subSkills.length, 150);
}
